/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneLoader as ResolvedStandaloneLoader } from 'base/components/standalone/Loader';

export const Loader: typeof ResolvedStandaloneLoader = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneLoader {...props} />
        </ErrorBoundary>
    );
});

export type LoaderProps = PropsFromComponent<typeof Loader>;

/** @deprecated Use slot architecture instead */
export const LoaderWith = (extras: DynamicStandaloneExtras): typeof Loader => {
    return function Loader(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Loader');
        return <ResolvedStandaloneLoader {...mergeProps({ options: { theme } }, props)} />;
    }
}